import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Row } from 'react-bootstrap';
import cn from 'classnames';
import Title from '../../../event_components/title';
import Details from '../../../event_components/details';
import AttendButton from '../../../event_components/attend_button';
import styles from './tile.scss';
import PaddedComponent from '../../shared/top_padder';
import ConferenceData from '../../../event_components/conference_data';
import EventStatus from '../../../event_components/event_status';
import AddEventToCalendar from '../../../event_components/add_to_calendar';
import Host from '../../../event_components/host';
import CheckoutController from '../../../event_components/Checkout';
import { attendButtonIsVisible } from '../../shared/utils';
import Gallery from '../gallery';
import { LocationItem } from '../location-item/location-item';
import { EventDate } from '../../../event_components/event-date';
import { EventTime } from '../../../event_components/event-time';
import DateRangeIcon from '@mui/icons-material/DateRange';
import WatchLaterSharpIcon from '@mui/icons-material/WatchLaterSharp';

PaddedComponent.propTypes = {
  children: PropTypes.node,
};

class Tile extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: false,
    };
  }

  toggleAttendButton = () => {
    const { event, onResizeComponent } = this.props;

    if (event.get('type') === 'google') {
      return;
    }
    this.setState(
      {
        openTicketing: !this.state.openTicketing,
      },
      () => onResizeComponent && onResizeComponent()
    );
  };

  render() {
    const { event, settings, noTitle = false, className = '', onResizeComponent } = this.props;

    const hasLogo = settings.get('showEventLogo');

    return (
      <CheckoutController
        variant="default"
        event={event}
        settings={settings}
        openTicketing={this.state.openTicketing}
        onResizeComponent={onResizeComponent}
        transitionClassName="checkout-transition"
        onClose={() => {
          this.setState({
            openTicketing: false,
          });
        }}
      >
        <Row className={cn('event', styles.tile, styles.event, className)} key={event.get('id')}>
          {hasLogo && (
            <div className={styles.galleryWrapper}>
              <Gallery event={event} />
            </div>
          )}

          <div className={styles.details}>
            {!noTitle && <Title event={event} settings={settings} />}
            <div className={styles.eventFactsList}>
              <LocationItem event={event} settings={settings} className={styles.locationItem} />
              <div className={styles.factItem}>
                <DateRangeIcon alt="date" width="20px" className="date" />
                <EventDate event={event} settings={settings} />
              </div>
              <div className={styles.factItem}>
                <WatchLaterSharpIcon alt="time" width="20px" className="date" />
                <EventTime event={event} settings={settings} />
              </div>
            </div>

            {settings.get('showEventStatus') && <EventStatus event={event} settings={settings} />}
            {settings.get('enableAddToCalendar') && <AddEventToCalendar event={event} settings={settings} className={styles.addToCalendar} />}
            {event.has('conferenceData') && (
              <PaddedComponent>
                <ConferenceData event={event} />{' '}
              </PaddedComponent>
            )}
            <Details event={event} settings={settings} className={styles.description} onResizeComponent={onResizeComponent} />
            {event.get('type') === 'zoom' && <Host event={event} settings={settings} className={styles.zoomHost} />}
          </div>
          {attendButtonIsVisible(event, settings, this.state.openTicketing) && (
            <AttendButton event={event} settings={settings} className={styles.buttonRow} handleButtonClick={this.toggleAttendButton} />
          )}
        </Row>
      </CheckoutController>
    );
  }
}

Tile.propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export default Tile;
